// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9af6a67","732":"1fe0043d","977":"2c06274e"}[chunkId] + ".chunk.js";
};